import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  ArrowLeft,
  Building,
  User,
  Phone,
  Mail,
  CreditCard,
  Percent,
  Sun,
  Upload,
  Check,
  CheckCircle,
  X,
  Loader2
} from 'lucide-react';
import { companyProfileApi, authHelpers } from '../services/api';
import { useTheme } from '../context/ThemeContext';
import { message } from 'antd';
import { ASSET_BASE_URL as ASSET_URL } from '../services/api';

function AddBillProfile() {
  const { currentTheme } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const isEdit = location.state?.isEdit || false;
  const editProfile = location.state?.profile || null;

  const [formData, setFormData] = useState({
    companyName: editProfile?.companyName || editProfile?.company_name || '',
    name: editProfile?.name || '',
    contactNumber: editProfile?.contactNumber || editProfile?.contact_number || '',
    email: editProfile?.email || '',
    panNumber: editProfile?.panNumber || editProfile?.pan_number || '',
    gstNumber: editProfile?.gstNumber || editProfile?.gst_number || '',
    fssaiNumber: editProfile?.fssaiNumber || editProfile?.fssai_number || '',
    tagLine: editProfile?.tagLine || editProfile?.tag_line || ''
  });
// ✅ REPLACE: existingImages prefill useEffect
useEffect(() => {
  if (isEdit && editProfile) {
    // Backend sirf filename return karta hai — pura URL banana padega
    const BASE_IMG = `${ASSET_URL}/uploads/`;

    const toFullUrl = (val) => {
      if (!val) return null;
      // Agar pehle se full URL hai to as-is return karo
      if (val.startsWith('http')) return val;
      // Warna BASE_URL prefix lagao
      return BASE_IMG + val;
    };

    setExistingImages({
      companyLogo: toFullUrl(
        editProfile.companyLogoUrl || editProfile.company_logo_url ||
        editProfile.companyLogo   || editProfile.company_logo
      ),
      signature: toFullUrl(
        editProfile.signatureUrl   || editProfile.signature_url ||
        editProfile.signature
      ),
      upiScanner: toFullUrl(
        editProfile.upiScannerUrl  || editProfile.upi_scanner_url ||
        editProfile.upiScanner     || editProfile.upi_scanner
      ),
    });
  }
}, [isEdit, editProfile]);
  // Force reset if not editing (fixes hot reload state issues)
  useEffect(() => {
    if (!editProfile) {
      setFormData({
        companyName: '',
        name: '',
        contactNumber: '',
        email: '',
        panNumber: '',
        gstNumber: '',
        fssaiNumber: '',
        tagLine: ''
      });
    }
  }, [editProfile]);

  // ✅ REPLACE existing existingImages useState
const BASE_IMG = `${ASSET_URL}/uploads/`;

const toFullUrl = (val) => {
  if (!val) return null;
  if (val.startsWith('http')) return val;
  return BASE_IMG + val;
};
 const [uploadedFiles, setUploadedFiles] = useState({
  companyLogo: location.state?.uploadedFiles?.companyLogo || null,
  signature:   location.state?.uploadedFiles?.signature   || null,
  upiScanner:  location.state?.uploadedFiles?.upiScanner  || null,
});

 const [existingImages, setExistingImages] = useState(() => {
  // Agar Step 2 se Previous aya hai — wahan se restore karo
  if (location.state?.existingImages) {
    const imgs = location.state.existingImages;
    return {
      companyLogo: toFullUrl(imgs.companyLogo),
      signature:   toFullUrl(imgs.signature),
      upiScanner:  toFullUrl(imgs.upiScanner),
    };
  }
  // Fresh edit mode — editProfile se set karo
  if (isEdit && editProfile) {
    return {
      companyLogo: toFullUrl(
        editProfile.companyLogoUrl || editProfile.company_logo_url ||
        editProfile.companyLogo   || editProfile.company_logo
      ),
      signature: toFullUrl(
        editProfile.signatureUrl   || editProfile.signature_url ||
        editProfile.signature
      ),
      upiScanner: toFullUrl(
        editProfile.upiScannerUrl  || editProfile.upi_scanner_url ||
        editProfile.upiScanner     || editProfile.upi_scanner
      ),
    };
  }
  return { companyLogo: null, signature: null, upiScanner: null };
});


  const [errors, setErrors] = useState({});
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // Auto-hide notification after 3 seconds
  useEffect(() => {
    if (showNotification) {
      const timer = setTimeout(() => {
        setShowNotification(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showNotification]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  // ✅ FIXED: Append input to DOM so it doesn't get garbage collected
  const handleFileUpload = (field) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/png,image/jpeg,image/jpg';
    input.style.display = 'none';

    input.onchange = (e) => {
      const file = e.target.files[0];
      if (file) {
        if (
          file.type === 'image/png' ||
          file.type === 'image/jpeg' ||
          file.type === 'image/jpg'
        ) {
          setUploadedFiles(prev => ({
            ...prev,
            [field]: file
          }));
          // Clear existing image since user uploaded a new one
          setExistingImages(prev => ({
            ...prev,
            [field]: null
          }));
          if (errors[field]) {
            setErrors(prev => ({ ...prev, [field]: '' }));
          }
        } else {
          message.warning('Only PNG, JPG or JPEG files are accepted');
        }
      }
      document.body.removeChild(input);
    };

    input.oncancel = () => {
      document.body.removeChild(input);
    };

    document.body.appendChild(input);
    input.click();
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.companyName.trim()) {
      newErrors.companyName = 'Company name is required';
    }
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }
    if (!formData.contactNumber.trim()) {
      newErrors.contactNumber = 'Contact number is required';
    }
    if (!formData.panNumber.trim()) {
      newErrors.panNumber = 'PAN number is required';
    }
    if (!formData.gstNumber.trim()) {
      newErrors.gstNumber = 'GST number is required';
    }
    if (!formData.fssaiNumber.trim()) {
      newErrors.fssaiNumber = 'FSSAI number is required';
    }
    if (!formData.tagLine.trim()) {
      newErrors.tagLine = 'Tag line is required';
    }

    // ✅ UPDATED: Check both new upload AND existing image URL
    if (!uploadedFiles.companyLogo && !existingImages.companyLogo) {
      newErrors.companyLogo = 'Company logo is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (!validateForm()) {
      return;
    }

    let step2Data = location.state?.step2Data;

    if (isEdit && editProfile && !step2Data) {
      step2Data = {
        locality: editProfile.locality,
        areaPinCode: editProfile.areaPinCode || editProfile.area_pin_code,
        district: editProfile.district,
        state: editProfile.state,
        savedInstructions: (editProfile.instructionNotes || editProfile.instruction_notes || []).map((inst, idx) => ({
          id: idx + 1,
          type: inst.instructionType || inst.instruction_type,
          text: inst.instruction || inst.text
        }))
      };
    }

    // ✅ Pass existingImages to step 2 so backend knows which images to keep
    navigate('/billing/add-profile/step2', {
      state: {
        formData,
        uploadedFiles,
        existingImages,
        isEdit,
        profileId: editProfile?.id,
        step2Data
      }
    });
  };

  // ✅ UPDATED: Reusable upload box with existing image preview support
  const UploadBox = ({ field, label, required = false, height = 'p-4' }) => {
    const hasNewFile = uploadedFiles[field];
    const hasExistingImage = existingImages[field];

    // Show uploaded file info
    if (hasNewFile) {
      return (
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1.5">
            {label} {required && <span className="text-red-500">*</span>}
          </label>
          <div className="border-2 rounded-lg p-3 bg-white" style={{ borderColor: currentTheme.color }}>
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                {/* Image preview for new file */}
                <div className="w-10 h-10 rounded-lg overflow-hidden flex-shrink-0 border border-gray-200">
                  <img
                    src={URL.createObjectURL(hasNewFile)}
                    alt={label}
                    className="w-full h-full object-cover"
                    onLoad={(e) => URL.revokeObjectURL(e.target.src)}
                  />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate">{hasNewFile.name}</p>
                  <p className="text-xs text-gray-500">{(hasNewFile.size / 1024).toFixed(2)} KB</p>
                </div>
              </div>
              <div className="flex items-center gap-2 ml-2 flex-shrink-0">
                <button
                  onClick={() => handleFileUpload(field)}
                  className="text-xs font-medium px-2 py-1 rounded-md transition-colors"
                  style={{ color: currentTheme.color, backgroundColor: `${currentTheme.color}15` }}
                >
                  Change
                </button>
                <button
                  onClick={() => setUploadedFiles(prev => ({ ...prev, [field]: null }))}
                  className="text-red-500 hover:text-red-700 text-sm"
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
          {errors[field] && (
            <p className="text-red-500 text-xs mt-1">{errors[field]}</p>
          )}
        </div>
      );
    }

    // ✅ Show existing image from backend (edit mode)
    if (hasExistingImage) {
      return (
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1.5">
            {label} {required && <span className="text-red-500">*</span>}
          </label>
          <div className="border-2 rounded-lg p-3 bg-white" style={{ borderColor: currentTheme.color }}>
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                {/* Image preview from URL */}
                <div className="w-10 h-10 rounded-lg overflow-hidden flex-shrink-0 border border-gray-200">
                  <img
                    src={hasExistingImage}
                    alt={label}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentElement.innerHTML = `
                        <div class="w-full h-full bg-green-50 flex items-center justify-center">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M9 12l2 2 4-4" stroke="#459B7A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z" stroke="#459B7A" stroke-width="2"/>
                          </svg>
                        </div>
                      `;
                    }}
                  />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate">
                    {label} uploaded
                  </p>
                  <p className="text-xs text-green-600">Existing image</p>
                </div>
              </div>
              <div className="flex items-center gap-2 ml-2 flex-shrink-0">
                <button
                  onClick={() => handleFileUpload(field)}
                  className="text-xs font-medium px-2 py-1 rounded-md transition-colors"
                  style={{ color: currentTheme.color, backgroundColor: `${currentTheme.color}15` }}
                >
                  Change
                </button>
                <button
                  onClick={() => setExistingImages(prev => ({ ...prev, [field]: null }))}
                  className="text-red-500 hover:text-red-700 text-sm"
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
          {errors[field] && (
            <p className="text-red-500 text-xs mt-1">{errors[field]}</p>
          )}
        </div>
      );
    }

    // Show upload placeholder
    return (
      <div>
        <label className="block text-xs font-medium text-gray-700 mb-1.5">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
        <div
          onClick={() => handleFileUpload(field)}
          className={`border-2 border-dashed rounded-lg ${height} bg-white cursor-pointer hover:bg-gray-50 transition-colors`}
          style={{ borderColor: errors[field] ? '#EF4444' : '#D1D5DB' }}
        >
          <div className="flex flex-col items-center justify-center space-y-1.5 h-full">
            <Upload className="w-6 h-6 text-gray-400" />
            <p className="text-xs font-medium text-gray-700">Upload {label.toLowerCase()}</p>
            <p className="text-xs text-gray-500 text-center">Only PNG, JPG or JPEG files are accepted</p>
          </div>
        </div>
        {errors[field] && (
          <p className="text-red-500 text-xs mt-1">{errors[field]}</p>
        )}
      </div>
    );
  };

  return (
    <div className="space-y-6 pb-[150px]">
      {/* Success Notification Popup */}
      {showNotification && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-start justify-center z-50 pt-20">
          <div
            className="bg-white border-2 rounded-xl px-6 py-4 flex items-center gap-4 shadow-2xl min-w-[300px] max-w-[400px]"
            style={{ borderColor: currentTheme.color }}
          >
            <div
              className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: currentTheme.color }}
            >
              <CheckCircle className="w-6 h-6 text-white" />
            </div>
            <p className="text-base font-medium text-gray-800 flex-1">{notificationMessage}</p>
            <button
              onClick={() => setShowNotification(false)}
              className="w-7 h-7 bg-red-100 hover:bg-red-200 rounded-full flex items-center justify-center flex-shrink-0 transition-colors"
            >
              <X className="w-4 h-4 text-red-600" />
            </button>
          </div>
        </div>
      )}

      {/* Header */}
      <div className="flex items-center space-x-4">
        <button
          onClick={() => navigate('/billing/self-profile')}
          className="w-10 h-10 flex items-center justify-center bg-white rounded-full border border-gray-300 hover:bg-gray-50 transition-colors shadow-sm"
        >
          <ArrowLeft className="w-5 h-5 text-gray-600" />
        </button>
        <h1 className="text-2xl font-bold text-gray-800">
          {isEdit ? 'Edit bill profile' : 'Add new bill profile'}
        </h1>
      </div>

      {/* Main Content - Two Columns */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">

        {/* Left Column - Form Details */}
        <div className="lg:col-span-2 space-y-4">

          {/* Company Details Section */}
          <div className="bg-white rounded-xl border border-gray-200 shadow-md p-4">
            <h2 className="text-base font-bold text-gray-800 mb-3">Company details</h2>
            <div className="space-y-3">

              {/* Company Name */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                  Company name <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <Building className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="text"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleChange}
                    className={`w-full pl-9 pr-3 py-2 bg-gray-50 border-2 rounded-lg focus:outline-none text-sm transition-all ${errors.companyName ? 'border-red-500' : ''}`}
                    style={{ borderColor: !errors.companyName && formData.companyName ? currentTheme.color : errors.companyName ? '#EF4444' : '#E5E7EB' }}
                  />
                </div>
                {errors.companyName && <p className="text-red-500 text-xs mt-1">{errors.companyName}</p>}
              </div>

              {/* Name */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                  Name <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <User className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className={`w-full pl-9 pr-3 py-2 bg-gray-50 border-2 rounded-lg focus:outline-none text-sm transition-all`}
                    style={{ borderColor: !errors.name && formData.name ? currentTheme.color : errors.name ? '#EF4444' : '#E5E7EB' }}
                  />
                </div>
                {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
              </div>

              {/* Contact Number */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                  Contact number <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <Phone className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="tel"
                    name="contactNumber"
                    value={formData.contactNumber}
                    onChange={handleChange}
                    maxLength={10}
                    className={`w-full pl-9 pr-3 py-2 bg-gray-50 border-2 rounded-lg focus:outline-none text-sm transition-all`}
                    style={{ borderColor: !errors.contactNumber && formData.contactNumber ? currentTheme.color : errors.contactNumber ? '#EF4444' : '#E5E7EB' }}
                  />
                </div>
                {errors.contactNumber && <p className="text-red-500 text-xs mt-1">{errors.contactNumber}</p>}
              </div>

              {/* Email */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1.5">Email</label>
                <div className="relative">
                  <Mail className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full pl-9 pr-3 py-2 bg-gray-50 border-2 rounded-lg focus:outline-none text-sm transition-all"
                    style={{ borderColor: formData.email ? currentTheme.color : '#E5E7EB' }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Basic Details Section */}
          <div className="bg-white rounded-xl border border-gray-200 shadow-md p-4" style={{ marginTop: '40px' }}>
            <h2 className="text-base font-bold text-gray-800 mb-3">Basic details</h2>
            <div className="flex flex-wrap gap-4">

              {/* PAN Number */}
              <div className="flex-1 min-w-[200px]">
                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                  Pan number <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <CreditCard className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="text"
                    name="panNumber"
                    value={formData.panNumber}
                    onChange={handleChange}
                    className="w-full pl-9 pr-3 py-2 bg-gray-50 border-2 rounded-lg focus:outline-none text-sm transition-all"
                    style={{ borderColor: !errors.panNumber && formData.panNumber ? currentTheme.color : errors.panNumber ? '#EF4444' : '#E5E7EB' }}
                  />
                </div>
                {errors.panNumber && <p className="text-red-500 text-xs mt-1">{errors.panNumber}</p>}
              </div>

              {/* GST Number */}
              <div className="flex-1 min-w-[200px]">
                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                  GST number <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <Percent className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="text"
                    name="gstNumber"
                    value={formData.gstNumber}
                    onChange={handleChange}
                    className="w-full pl-9 pr-3 py-2 bg-gray-50 border-2 rounded-lg focus:outline-none text-sm transition-all"
                    style={{ borderColor: !errors.gstNumber && formData.gstNumber ? currentTheme.color : errors.gstNumber ? '#EF4444' : '#E5E7EB' }}
                  />
                </div>
                {errors.gstNumber && <p className="text-red-500 text-xs mt-1">{errors.gstNumber}</p>}
              </div>

              {/* FSSAI Number */}
              <div className="flex-1 min-w-[200px]">
                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                  FSSAI number <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <Sun className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="text"
                    name="fssaiNumber"
                    value={formData.fssaiNumber}
                    onChange={handleChange}
                    className="w-full pl-9 pr-3 py-2 bg-gray-50 border-2 rounded-lg focus:outline-none text-sm transition-all"
                    style={{ borderColor: !errors.fssaiNumber && formData.fssaiNumber ? currentTheme.color : errors.fssaiNumber ? '#EF4444' : '#E5E7EB' }}
                  />
                </div>
                {errors.fssaiNumber && <p className="text-red-500 text-xs mt-1">{errors.fssaiNumber}</p>}
              </div>
            </div>

            {/* Next Button */}
            <div className="mt-4 flex justify-end">
              <button
                type="button"
                onClick={handleNext}
                disabled={submitting}
                className="px-5 py-2 text-white text-sm font-medium rounded-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 shadow-md"
                style={{ backgroundColor: currentTheme.color }}
              >
                {submitting && <Loader2 className="w-4 h-4 animate-spin" />}
                Next
              </button>
            </div>
          </div>
        </div>

        {/* Right Column - Attachment Section */}
        <div className="lg:col-span-1">
          <div className="bg-white rounded-xl border border-gray-200 shadow-md p-4">
            <h2 className="text-base font-bold text-gray-800 mb-3">Attachment</h2>
            <div className="space-y-4">
              <UploadBox field="companyLogo" label="Company Logo" required height="p-4" />
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                  Tag line <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="tagLine"
                  value={formData.tagLine}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-gray-50 border-2 rounded-lg focus:outline-none text-sm transition-all"
                  style={{ borderColor: !errors.tagLine && formData.tagLine ? currentTheme.color : errors.tagLine ? '#EF4444' : '#E5E7EB' }}
                />
                {errors.tagLine && <p className="text-red-500 text-xs mt-1">{errors.tagLine}</p>}
              </div>
              <UploadBox field="signature" label="Signature" height="p-4" />
              <UploadBox field="upiScanner" label="UPI Scanner" height="p-6" />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default AddBillProfile;